import React, { Component } from 'react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };
  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return this.props.fallback || <div className="p-4 bg-red-500 bg-opacity-20 border border-red-500 rounded-lg text-white" data-id="element-74">
            <h2 className="text-xl font-bold mb-2" data-id="element-75">Something went wrong</h2>
            <details className="text-sm opacity-80" data-id="element-76">
              <summary data-id="element-77">Error details</summary>
              <pre className="mt-2 p-2 bg-black bg-opacity-50 rounded overflow-auto" data-id="element-78">
                {this.state.error?.toString()}
              </pre>
            </details>
          </div>;
    }
    return this.props.children;
  }
}